"use strict";
/**
 * This file has been generated
 * DO NOT EDIT, IT MAY BE OVERWRITTEN
 */
Object.defineProperty(exports, "__esModule", { value: true });
var TapRequest;
(function (TapRequest) {
    var MethodType;
    (function (MethodType) {
        MethodType[MethodType["GET"] = 1] = "GET";
        MethodType[MethodType["POST"] = 2] = "POST";
        MethodType[MethodType["PUT"] = 3] = "PUT";
    })(MethodType = TapRequest.MethodType || (TapRequest.MethodType = {}));
})(TapRequest = exports.TapRequest || (exports.TapRequest = {}));
var TapApduRequest;
(function (TapApduRequest) {
    var MethodType;
    (function (MethodType) {
        MethodType[MethodType["GET"] = 202] = "GET";
        MethodType[MethodType["PUT_OR_POST"] = 218] = "PUT_OR_POST";
    })(MethodType = TapApduRequest.MethodType || (TapApduRequest.MethodType = {}));
    var Default;
    (function (Default) {
        Default[Default["CLA"] = 162] = "CLA";
    })(Default = TapApduRequest.Default || (TapApduRequest.Default = {}));
})(TapApduRequest = exports.TapApduRequest || (exports.TapApduRequest = {}));
